<!-- Warnings -->

<!-- No payment enabled for direct warning-->
<sbnb-alert-card
  *ngIf="activeReservation && activeReservation.payment_enabled === false && activeReservation.platform === 'direct'"
  [context]="(isDirectOnboarded$ | async) === true ? 'negative' : 'warning'"
  class="gap-2">
  <sbnb-icon
    icon="alert-triangle"
    [ngClass]="{
      'text-lemon-darker': (isDirectOnboarded$ | async) !== true,
      'text-rose-darker': (isDirectOnboarded$ | async) === true
    }"></sbnb-icon>
  <span class="flex-1">
    Hospitable is not configured to collect payment from the guest on this reservation. To enable payment processing for
    future reservations, select a Direct plan and add set a payout method for this property.
  </span>
</sbnb-alert-card>

<!-- Direct Alteration - payment processing warning -->
<sbnb-alert-card *ngIf="activeReservation?.pending_alteration === true" context="neutral" class="gap-2">
  <sbnb-icon icon="details"></sbnb-icon>
  <span class="flex-1">The alteration has been requested successfully, we are now processing the payment.</span>
</sbnb-alert-card>

<!-- Booking request pending -->
<!-- This is getting way too complex and needs a clean up. We're temporarily introducing 2 streams of Guest vetting data -->
<!-- For now, I'm just going to create an entirely new section for GVS -->
<sbnb-alert-card
  *ngIf="
    thread?.status === 'Pending' && activeReservation && guestVetting()?.provider !== GuestVerificationProvider.GVS
  "
  context="warning"
  class="gap-2">
  <sbnb-icon icon="post-stay" class="text-lemon-darker flex-shrink-0"></sbnb-icon>

  <span *ngIf="activeReservation?.payment_enabled === false">There is a booking request pending.</span>

  <ng-container *ngIf="activeReservation?.payment_enabled === true">
    <ng-container *ngIf="activeReservation?.is_custom_quote === false">
      <ng-container
        *ngIf="
          this.verificationInReview || guestVettingData?.summary?.guest_portal_status === GuestPortalStatus.INCOMPLETE;
          else nonCustomQuotePaymentRelatedMessages
        ">
        <ng-container
          *ngIf="verificationInReview && guestVettingData?.summary?.reservation_status !== ReservationStatus.ACCEPTED">
          This is a pending request to book that is awaiting manual review by Hospitable's support team. You may deny
          the request at any time to unblock your calendar.
        </ng-container>

        <ng-container *ngIf="guestVettingData?.summary?.guest_portal_status === GuestPortalStatus.INCOMPLETE">
          This is a pending request to book awaiting completion of the guest vetting portal by the guest. Your guest has
          until
          {{ activeReservation.expires_at | date: 'medium' }} to successfully complete the guest vetting requirements.
          You may deny the request at any time to unblock your calendar.
        </ng-container>
      </ng-container>

      <ng-template #nonCustomQuotePaymentRelatedMessages>
        <ng-container [ngSwitch]="activeReservation?.payment_status">
          <span *ngSwitchCase="'capture_pending'">
            <ng-container *ngTemplateOutlet="capturePendingMessage"></ng-container>
          </span>
          <span *ngSwitchCase="'cancellation_pending'">
            <ng-container *ngTemplateOutlet="cancellationPendingMessage"></ng-container>
          </span>
          <span *ngSwitchDefault>
            You have a pending booking request. Accept the request within 24 hours to confirm the booking and capture
            the payment. Reject the request to decline the booking and unblock your calendar.
          </span>
        </ng-container>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="activeReservation?.is_custom_quote === true">
      <ng-container
        *ngIf="
          guestVettingData?.summary?.verification_status === VerificationStatus.REVIEW ||
            guestVettingData?.summary?.guest_portal_status === GuestPortalStatus.INCOMPLETE;
          else paymentRelatedMessages
        ">
        <ng-container
          *ngIf="
            guestVettingData?.summary?.verification_status === VerificationStatus.REVIEW &&
            guestVettingData?.summary?.reservation_status !== ReservationStatus.ACCEPTED
          ">
          This is a pending reservation that is awaiting manual review by Hospitable's support team. You may cancel the
          quote at any time to unblock your calendar.
        </ng-container>

        <ng-container *ngIf="guestVettingData?.summary?.guest_portal_status === GuestPortalStatus.INCOMPLETE">
          This is a pending request to book awaiting completion of the guest vetting portal by the guest. Your guest has
          until
          {{ activeReservation.expires_at | date: 'medium' }} to successfully complete the guest vetting requirements.
          You may cancel the quote at any time to unblock your calendar.
        </ng-container>
      </ng-container>

      <ng-template #paymentRelatedMessages>
        <ng-container [ngSwitch]="activeReservation?.payment_status">
          <span *ngSwitchCase="'capture_pending'">
            <ng-container *ngTemplateOutlet="capturePendingMessage"></ng-container>
          </span>
          <span *ngSwitchCase="'cancellation_pending'">
            <ng-container *ngTemplateOutlet="cancellationPendingMessage"></ng-container>
          </span>
          <span *ngSwitchCase="'authorised'">
            This is a pending reservation awaiting completion of the guest vetting portal by the guest. Your guest has
            until {{ activeReservation.expires_at | date: 'medium' }} to successfully complete the guest vetting
            requirements. You may cancel the quote at any time to unblock your calendar.
          </span>
          <span *ngSwitchDefault>
            This is a pending reservation awaiting payment from the guest. Your guest has until
            {{ activeReservation.expires_at | date: 'medium' }} to complete the payment before the quote expires. You
            may cancel the quote at any time to unblock your calendar.
          </span>
        </ng-container>
      </ng-template>
    </ng-container>

    <ng-template #capturePendingMessage>
      You've accepted this booking request, we are now processing the payment.
    </ng-template>

    <ng-template #cancellationPendingMessage>
      You've cancelled this booking request, we are now cancelling the payment.
    </ng-template>
  </ng-container>
</sbnb-alert-card>

<!-- Payment status - GVS only -->
<sbnb-alert-card
  *ngIf="
    thread?.status === 'Pending' &&
    guestVetting()?.provider === GuestVerificationProvider.GVS &&
    activeReservation &&
    activeReservation?.payment_enabled === true &&
    activeReservation?.is_custom_quote === false &&
    (activeReservation?.payment_status === 'capture_pending' ||
      activeReservation?.payment_status === 'cancellation_pending')
  "
  context="warning"
  class="gap-2">
  <sbnb-icon icon="post-stay" class="text-lemon-darker flex-shrink-0"></sbnb-icon>
  <ng-container [ngSwitch]="activeReservation?.payment_status">
    <span *ngSwitchCase="'capture_pending'">
      <ng-container *ngTemplateOutlet="capturePendingMessage"></ng-container>
    </span>
    <span *ngSwitchCase="'cancellation_pending'">
      <ng-container *ngTemplateOutlet="cancellationPendingMessage"></ng-container>
    </span>
  </ng-container>

  <ng-template #capturePendingMessage>
    You've accepted this booking request, we are now processing the payment.
  </ng-template>

  <ng-template #cancellationPendingMessage>
    You've rejected this booking request, we are now cancelling the payment.
  </ng-template>
</sbnb-alert-card>

<sbnb-alert-card
  *ngIf="
    thread?.status === 'Pending' &&
    guestVetting()?.provider === GuestVerificationProvider.GVS &&
    activeReservation &&
    activeReservation?.payment_enabled === true &&
    activeReservation?.is_custom_quote === false &&
    activeReservation?.payment_status !== 'capture_pending' &&
    activeReservation?.payment_status !== 'cancellation_pending'
  "
  context="warning"
  class="gap-2">
  <sbnb-icon icon="post-stay" class="text-lemon-darker flex-shrink-0"></sbnb-icon>

  <ng-container *ngIf="guestVetting()?.status === VerificationRatingStatus.PENDING">
    This booking request is currently pending, awaiting completion of the guest vetting process. Your guest has until
    {{ activeReservation.expires_at | date: 'medium' }} to successfully complete the guest vetting requirements. You may
    deny the request at any time to unblock your calendar.
  </ng-container>

  <ng-container *ngIf="guestVetting()?.status === VerificationRatingStatus.REVIEW">
    This is a pending request to book that is awaiting manual review by Hospitable's support team. You may deny the
    request at any time to unblock your calendar.
  </ng-container>

  <ng-container
    *ngIf="
      guestVetting()?.status === VerificationRatingStatus.SUSPECTED ||
      guestVetting()?.status === VerificationRatingStatus.APPROVED
    ">
    You have a pending booking request. Accept the request within 24 hours to confirm the booking and capture the
    payment. Reject the request to decline the booking and unblock your calendar.
  </ng-container>
</sbnb-alert-card>

<!-- Scheduled messages paused due to incomplete guest portal requirements on the guest. -->
<!-- TODO: Update ngIf to check for rental agreements TBD tom -->
<sbnb-alert-card *ngIf="activeReservation?.scheduled_messages_paused" context="warning" class="flex flex-col gap-2">
  <h3 class="mb-2">Scheduled messages are paused until the guest completes the guest portal.</h3>
  <div class="mb-2 flex-row">
    <div>Check-in messages and code communications will not be sent until the guest completes the pending tasks.</div>
  </div>
</sbnb-alert-card>

<sbnb-alert-card
  *ngIf="
    activeReservation?.autohost &&
    activeReservation?.autohost.source === 'adhoc' &&
    activeReservation?.autohost.supervised !== 'approve' &&
    activeReservation?.autohost.status === 'review'
  "
  context="warning"
  class="flex flex-col mt-2">
  <h3 class="mb-2">Autohost has flagged this guest for manual review.</h3>
  <div class="mb-2 flex row">
    The guest has completed the verification process, but further review is required. Scheduled messages are paused,
    pending your review.
  </div>
  <div class="flex justify-end mt-1">
    <sbnb-button
      size="mini"
      [label]="'Review verification'"
      (click)="
        openVettingDetails({
          reservation: activeReservation,
          autohostBasicDetails: activeReservation.autohost
        })
      "></sbnb-button>
  </div>
</sbnb-alert-card>

<!--Payment term capture payment failure -->
<sbnb-alert-card *ngIf="paymentTermThatCanBeExtended" context="warning" class="flex-col">
  <div class="flex flex-col">
    <span class="text-md font-bold">We were unable to capture a scheduled payment.</span>
    <span class="mt-4">
      The guest has been notified and provided a link to complete the payment with another card. We will continue to
      attempt to capture the payment until the grace period ends on
      {{ paymentTermThatCanBeExtended?.grace_period_end | date: 'MMMM' }}
      {{ addOrdinalSuffix(paymentTermThatCanBeExtended?.grace_period_end | date: 'dd') }}
      {{ formatTime(paymentTermThatCanBeExtended?.grace_period_end) }} at which point the reservation will be cancelled.
    </span>
  </div>

  <div class="flex flex-col mt-6">
    <sbnb-button size="mini" [label]="'Extend grace period'" (click)="showExtendGracePeriodDialog()"></sbnb-button>
  </div>
</sbnb-alert-card>
